import { IApiClient, compressAndBase62Encode } from '../common';

const dummyHost = "http://localhost:3000/";

class BetBuilderService {

    _baseRoute = "bet-slips";

    apiClient: IApiClient;
    callerEnvironment: string;
    getLanguage: any;

    constructor(options) {

        this.resolveOptions(options);
    }

    resolveOptions(options) {
        this.apiClient = options.apiClient;
        this.callerEnvironment = options.callerEnvironment;
        if (typeof options.getLanguage === "function") {
            this.getLanguage = options.getLanguage;
        }
    }

    private createRelativeUrl(urlRoute: string, filter: string) {

        const url = new URL(dummyHost + urlRoute);
        url.searchParams.set('filter', filter);
        url.searchParams.set('Caller-Environment', this.callerEnvironment);

        return url.toString().slice(dummyHost.length);
    }

    async getNextOdds(offerFilter: any) {
        const urlRoute = this._baseRoute + "/next-odds";

        offerFilter.betBuilderOffers
            .sort((a, b) => a.eventId - b.eventId)
            .map(event => ({
                ...event,
                offerIds: event.offerIds.sort((a, b) => a - b)
            }));

        const filter = compressAndBase62Encode(this.injectAdditionalFieldsToOfferFilter(offerFilter));

        const relativeUrl = this.createRelativeUrl(urlRoute, filter);

        const response = await this.apiClient.get(relativeUrl);

        return response;
    }

    private injectAdditionalFieldsToOfferFilter(offerFilter: any) {
        if (this.getLanguage != null) {
            offerFilter.language = this.getLanguage();
        }

        return offerFilter;
    }
}


export default BetBuilderService;